export default __webpack_public_path__ + "2171287.png";